'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var getDisplayName = exports.getDisplayName = function getDisplayName(component) {
  return component.displayName || component.name || 'Component';
};

exports.default = {};


/*****************
 ** WEBPACK FOOTER
 ** ./~/@mayo/login-pass/lib/helper/util.js
 ** module id = 2258
 ** module chunks = 30 33 69 71
 **/